import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sender-profile-module',
  templateUrl: './sender-profile-module.component.html',
  styleUrls: ['./sender-profile-module.component.css']
})
export class SenderProfileModuleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
